import '../styles/main.css'
import '@/lib/select.js'
import lazim from 'lazim'
import app from '@/app.js'
// import router from '@/router.js'
import { fetchCart } from '@/lib/cart.js'
import { load } from "@shopify/theme-sections"
import '@/components/featured-articles.js'
import '@/components/blog-ajaxinate.js'
import { plpNavbar } from '@/components/collection.js'
import CustomScrollbar from '@/components/custom-scrollbar'

new CustomScrollbar();

import CustomerDrawer from "./components/customer-drawer";

new CustomerDrawer();

/**
 * store binding fn
 */
const images = lazim()

/**
 * bind on page load
 */
images()

// router.on('after', () => {
//   app.unmount()
//   app.mount()
//
//   /**
//    * bind new images
//    */
//   images()
// })

/**
 * load any data that your site needs on fist load
 */
Promise.all([
  fetchCart()
]).then(([ cart ]) => {
  /**
   * add the cart data to the picoapp instance
   */
  app.hydrate({ cart })

  /**
   * mount any components defined on the page
   */
  app.mount()

  load("*");
});

/* Lazy Loading */

if (matchMedia('screen and (min-width: 768px)').matches) {
  $('.lazy-desktop').each(function() {
    $(this).addClass('lazy');
    $(this).attr('data-lazy-src', $(this).attr('lazy-src'));
  })
}

$('.lazy').Lazy({
  attribute: 'data-lazy-src',
  threshold: 10000,
  visibleOnly: true,
  afterLoad: function(element) {
    element.addClass('lazy-loaded');
    let prodImage = element.closest('.js-product-image');
    
    if (prodImage.length) {
      prodImage.addClass('child-loaded');
    }
  },
  onFinishedAll: function() {
    plpNavbar();

    setTimeout(function() {
      hpGradient();
    }, 1000);
  }
});

function hpGradient() {
  const $gradientBg = $('.js-gradient-index');
  
  if ($gradientBg.length) {
    const footerHeight = $('.footer').outerHeight();
    const footerTop = $('.footer').offset().top;
    const $promoBanner = $('.promo-banner');
    
    if ($promoBanner.length) {
      const promobannerBottom = $promoBanner.offset().top + $promoBanner.outerHeight();
      
      $gradientBg.css({
        'top': promobannerBottom,
        'height': footerTop - promobannerBottom
      });
      
      $gradientBg.addClass('visible');
    }
  }
}

/* HP Gradient Background */
$(window).on('load', function() {
  hpGradient();
});
